'use strict';

import Loading from '../components/Loading';

const RequestComment = React.lazy(() => import( /* webpackChunkName: "RequestComment" */ '../components/RequestComment'));
const RequestFacilities = React.lazy(() => import( /* webpackChunkName: "RequestFacilities" */ '../components/RequestFacilities'));
const RequestPlaneCheckList = React.lazy(() => import( /* webpackChunkName: "RequestPlaneCheckList" */ '../components/RequestPlaneCheckList'));
const RequestSeatsForm = React.lazy(() => import( /* webpackChunkName: "RequestSeatsForm" */ '../components/RequestSeatsForm'));
const SearchRoutes = React.lazy(() => import( /* webpackChunkName: "SearchRoutes" */ '../components/SearchRoutes'));

class RequestContainer extends React.Component {
    constructor(props) {
        super(props);
        this.initState = {
            errors: {},
            isFetching: false,
            type: reactInitData.type || 'plane',
            airports: [],
            classes: [],
            additional: [],
            selectedClasses: [0],
            selectedAdditional: [],
            dealsCb: false,
            prices: {},
            routes: [{
                from: {
                    title: '',
                },
                to: {
                    title: '',
                },
                date: '',
                time: '',
                seats: 0,
            }],
            comment: '',
        }
        this.state = {...this.initState};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeRoutes = this.handleChangeRoutes.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    init() {
        this.setState({isFetching: true})
        requestAction.initData().then(response => {
            this.initState = {
                ...this.initState,
                isFetching: false,
                airports: response.airports,
                classes: response.classes,
                additional: response.additional,
            }
            this.setState(this.initState)
            this.setDataFromStorage()
        })
    }
    
    setDataFromStorage() {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('from_search')) {
            const reactSearchData = storageGetActualSearchData();
            if (reactSearchData.routesPlane && Array.isArray(reactSearchData.routesPlane) && reactSearchData.routesPlane.length > 0)
                this.setState({routes: reactSearchData.routesPlane});
        }
    }

    getTotalPrice() {
        const {prices, seats, seatsSofa, sofa} = this.state;
        let price = 0;
        if(prices.seat && seats) price += prices.seat * seats;
        if(prices.seatSofa && seatsSofa) price += prices.seatSofa * seatsSofa;
        if(prices.sofa && sofa) price += prices.sofa;
        return price;
    }

    handleChangeRoutes(routes) {
        const {type} = this.state;
        this.setState({routes}, () => {
            if(type === 'sharing') requestAction.fetchPrices({routes}).then(response => {
                this.setState(response);
            })
        })
    }

    validateRoutes() {
        const {type, routes} = this.state;

        let errors = [];
        let hasErrors = false

        routes.map((route, index) => {
            errors.push([]);
            if(!route.from.id) errors[index].push('from');
            if(!route.to.id) errors[index].push('to');
            if(!route.date) errors[index].push('date');

            if (['plane', 'sharing'].includes(type))
                if (!route.time) errors[index].push('time');
            if(type === 'plane')
                if (!route.seats) errors[index].push('seats');

            if(errors[index].length > 0) hasErrors = true;
        })

        this.setState({errors});
        return !hasErrors;
    }

    handleSubmit() {
        const {type, routes, seats, seatsSofa, sofa, selectedClasses, selectedAdditional, dealsCb, comment} = this.state;
        if(!checkAuth()) return;
        this.setState({isFetching: true})

        if (!this.validateRoutes()) {
            this.setState({isFetching: false})
            $('body, html').animate({scrollTop: 0}, 500);
            return;
        }

        requestAction.submitRequest({type, routes, seats, seatsSofa, sofa, selectedClasses, selectedAdditional, dealsCb, comment}).then(response => {
            this.setState({
                isFetching: false,
                errors: response.errors,
            })

            if(response.status === 'success') {

                if (type === 'plane')
                    ymReachGoal('plane_request')

                if (type === 'sharing')
                    ymReachGoal('jetsharing_request')

                if (type === 'emptyleg')
                    ymReachGoal('empty_legs_subscription')

                this.setState({...this.initState})
                successPopup(type, () => {
                    $('body, html').animate({scrollTop: 0}, 500);
                    if (feature_enabled('FEATURE_HEADER_NEW')) {
                        raiseEvent('showOrdersBeard', { type: 'requests', fetch: true });
                    } else {
                        raiseEvent('toggleSideBeard', { state: { type: 'requests', tab: 'current', filter: 'all' } });
                    }
                });
            }
        });
    }

    render() {
        const {title, subtitle, howItWorks} = reactInitData;
        const {errors, isFetching, type, routes, airports, classes, additional, selectedClasses, selectedAdditional, dealsCb, prices, comment} = this.state;

        let formClass = 'request-form request-form__plane';
        if(type === 'sharing') formClass = 'flight-app flight-app__request flight-app__request_sharing';
        if(type === 'emptyleg') formClass = '';

        return <div>
            <div className="request-banner">
                <div className="container">
                    <div className="request-banner__tag">
                        <span>{__('request.title')}</span>
                    </div>
                    <h1 className="request-banner__title">
                        {title}
                    </h1>
                    <div className="request-banner__text">
                        {subtitle}
                    </div>
                </div>
            </div>

            <div className="container">
                <React.Suspense>
                    <SearchRoutes
                        type={type}
                        requestMode={true}
                        routes={routes}
                        airports={airports}
                        onChangeRoutes={this.handleChangeRoutes}
                        errors={errors}
                        onlyAirports={false}
                    />
                </React.Suspense>
                <div className={formClass}>

                    {type === 'plane' && <React.Suspense>
                        <RequestPlaneCheckList
                            classes={classes}
                            additional={additional}
                            selectedClasses={selectedClasses}
                            selectedAdditional={selectedAdditional}
                            dealsCb={dealsCb}
                            showDeals={true}
                            onChange={selected => this.setState(selected)}
                        /> 
                    </React.Suspense>}

                    {type === 'sharing' && <React.Suspense>
                        <RequestSeatsForm
                            title={false}
                            prices={prices}
                            showPrice={true}
                            onChange={seats => this.setState(seats)}
                        />
                    </React.Suspense>}

                    {type === 'sharing' && <React.Suspense>
                        <RequestFacilities isSeats={true}/> 
                    </React.Suspense>}

                    <React.Suspense>
                        <RequestComment
                            containerClass={type === 'sharing' ? 'request-comment' : 'request'}
                            commment={comment}
                            onChange={comment => this.setState({comment})}
                        />
                    </React.Suspense>

                    <div className={type === 'emptyleg' ? 'request-form request-form__plane' : ''}>
                        <div className={type === 'sharing' ? 'request-item__control' : 'request-item__btn'}>
                            {type === 'sharing' && <div className="request-item__price">
                                {this.getTotalPrice().formatPrice()}
                            </div>}
                            <a className="button button-base" onClick={this.handleSubmit}>{__('request.sendRequest')}</a>
                        </div>
                        {this.state.errors['recaptcha'] && <div className="error-message text-center">{this.state.errors['recaptcha']}</div>}
                    </div>
                </div>
            </div>


            {howItWorks && <div>
                <div className="request-title">{__('request.howItWorks')}</div>
                <div className="request-work">
                    <div className="request-work__plane">
                        <i className="icon-plane2"/>
                    </div>
                    <div className="container">
                        <div className="request-work__row">
                            {howItWorks.map((item, index) => <div key={`howItWorks${index}`}  className="request-work__item">
                                <span>{index + 1}</span>
                                <p>{item}</p>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>}

            <Loading active={isFetching}/>
        </div>
    }
}

const domContainer = document.querySelector('#reactRequestContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(RequestContainer));
